export default {
  translation: {
    测试: "test",
  },
};
